import { useState, useEffect, useRef } from "react";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import {
  BookingDetailsHeaders,
  bookingEnquiryHeaders,
} from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Enquirypopup from "../popup-containers/Enquirypopup";
import PopUpButtons from "../components/PopUpButtons";
import { useNavigate } from "react-router-dom";
import OnLostPopUp from "../popup-containers/onLostPopUp";
import ConfirmBookingPopUp from "../popup-containers/ConfirmBookingPopUp";
import OnHoldPopUp from "../popup-containers/onHoldPopUp";
import { IUDAPI, BindPostAPI } from "../services/APIConnection";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import toast from "react-hot-toast";
import Cancelpopup from "../popup-containers/Cancelpopup";
import Loader from "../ReusableComponents/Loader";

const RoomBooking = () => {
  const [isLoading, setIsLoading] = useState(false);
  const today = new Date(); //.toISOString()
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    number: "",
    enquirydate: today,
    enquiryid: "ENQ-2025-000001",
    enquirytype: "",
    fromdate: "",
    todate: "",
    state: "",
    country: "",
    pincode: "",
    city: "",
    streetdoorno: "",
    area: "",
    idproof: "",
    idvalue: "",
    noofdays: "",
    sourcetype: "",
    source: "",
    referralcontact: "",
    roomtype: [],
    basictariff: "",
    specialtariff: "",
    amountpaid: "",
  });

  useEffect(() => {
    const { fromdate, todate } = formData;

    if (fromdate && todate) {
      const from = new Date(fromdate);
      const to = new Date(todate);
      const diffTime = to - from;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      setFormData((prev) => ({
        ...prev,
        noofdays: diffDays >= 0 ? diffDays.toString() : "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        noofdays: "",
      }));
    }
  }, [formData.fromdate, formData.todate]);
  const [onSubmit, setOnSubmit] = useState(false);
  const [viewPopUp, setViewPopUp] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({
    fname: "",
    lname: "",
    number: "",

    villaname: "",
    villatype: "",
    enquirydate: "",
    enquiryid: "",
    enquirytype: "",
    fromdate: "",
    todate: "",
    amount: "",
  });

  const [popUpData, setPopUpData] = useState([]);
  const [childId, setChildId] = useState(false);
  const [lostTableData, setLostTableData] = useState([]);

  const [villatypedropdown, setvillatypedropdown] = useState([
    { value: "1", label: "1BHK-AC" },
    { value: "2", label: "2BHK-AC " },
    { value: "3", label: "2BHK-Non-AC" },
  ]);
  const [iddropdown, setiddropdown] = useState([
    { value: "1", label: "Aadhar Card" },
    { value: "2", label: "Voter-ID" },
    { value: "3", label: "Passport Number" },
    { value: "4", label: "Driving License" },
  ]);

  const [referralsource, setreferralsource] = useState([]);
  const [roomtype, setroomtype] = useState([]);
  const [paymentType, setPaymentType] = useState([]);
  const [enquirytypedropdown, setenquirydropdown] = useState([]);

  const [countryDropdown, setCountryDropdown] = useState([]);

  const [stateDropdown, setStateDropdown] = useState([]);
  const [citydropdown, setCityDropdown] = useState([]);

  const fieldLabels = {
    fname: { label: "First Name", type: "text" },
    lname: { label: "Last Name", type: "text" },
    fromdate: { label: "Booking From", type: "date" },
    todate: { label: "Booking To", type: "date" },
    enquirytype: { label: "Enquiry Type", type: "select-one" },
    enquirydate: { label: "Enquiry Date", type: "date" },
    number: { label: "Mobile Number", type: "text" },
    // Add more fields here as needed
  };

  const [tableData, setTableData] = useState([]);

  const enquiryChilddata = [
    {
      mstRoomTypeId: tableData.MstRoomtypeId,
      mstRoomId: "",
      noOfAvailableRooms: tableData.AvailableRooms,
      basicTariff: tableData.Tariff,
      specialTariff: tableData.specialtariff,
      noOfRequiredRooms: tableData.numberofrooms,
      noOfAdults: tableData.numberfoadults,
      noOfChildren: tableData.numberofchildren,
      amount: tableData.amount,
      mstEnquiryStatusId: "",
      mstHoldReasonId: "",
      holdFollowUpDate: "",
      mstHoldReasonNotes: "",
      mstLostReasonId: "",
      mstLostReasonNotes: "",
    },
  ];



  const createdBy = sessionStorage.getItem("createdBy");
  const onSave = async (rowIndex, flag) => {
    const isValid = validateForm("save"); // Validate only save fields
    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        //setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (isValid) {
        setIsOpen(false);
        //setIsLoading(true);

        const enquiryChilddata = {
          txnEnquiryChildId: 0, // or existing ID if updating
          mstRoomTypeId: 1, // tableData.MstRoomtypeId,
          mstRoomId: 2, // Replace with valid ID or keep 0/null if not applicable
          noOfAvailableRooms: 4, // tableData.AvailableRooms,//parseInt(tableData.AvailableRooms),
          basicTariff: 500, //tableData.Tariff,//parseFloat(tableData.Tariff),
          specialTariff: 100, //tableData.specialtariff,//parseFloat(tableData.specialtariff),
          noOfRequiredRooms: 1, // tableData.numberofrooms,// parseInt(tableData.numberofrooms),
          noOfAdults: 2, // tableData.numberfoadults,//parseInt(tableData.numberfoadults),
          noOfChildren: 1, //tableData.numberofchildren,// parseInt(tableData.numberofchildren),
          amount: tableData.amount, // parseFloat(tableData.amount),
          mstEnquiryStatusId: 1,
          mstHoldReasonId: 0,
          holdFollowUpDate: "2025-07-12T10:31:31.862Z", //new Date().toLocaleDateString(), // or user input
          mstHoldReasonNotes: "Some note",
          mstLostReasonId: 0,
          lostReasonNotes: "Another note",
        };

        const data = {
          txnEnquiryId: 0,
          enquiryNo: "ENQ",
          enquiryDate: formData.enquirydate,
          mstEnquiryTypeId: formData.enquirytype || 0,
          bookingFrom: formData.fromdate,
          bookingTo: formData.todate,
          noOfDays: formData.noofdays || 0,
          //done
          firstName: formData.fname || "",
          lastName: formData.lname || "",
          mobileNumber: formData.number || "",
          //done
          mstCountryId: formData.country || 0,
          mstStateId: formData.state || 0,
          city: formData.city || "",
          streetDoorNo: formData.streetdoorno || "",
          area: formData.area || "",
          pincode: formData.pincode || "",
          mstSourceTypeId: formData.sourcetype || 0,
          contactNumber: formData.referralcontact || "",
          mstIdProofId: formData.idproof || 0,

          idNumber: formData.idvalue || "",
          source: formData.source || "",

          //belowdone
          amount: formData.amountpaid || 0,
          createdBy: createdBy,
          flag: flag,
          enquiryChild: JSON.stringify(tableData),
          //enquiryChild: '[{ \"mstRoomTypeId\": 1, \"mstRoomId\": 2, \"noOfAvailableRooms\": 2, \"basicTariff\": 2500, \"specialTariff\": 500, \"noOfRequiredRooms\": 1, \"noOfAdults\": 1, \"noOfChildren\": 2, \"amount\": 3500, \"mstEnquiryStatusId\": 1, \"mstHoldReasonId\": 0, \"holdFollowUpDate\": \"2025-07-11\", \"mstHoldReasonNotes\": \"Some note\", \"mstLostReasonId\": 0, \"lostReasonNotes\": \"Another note\" }]'
        };

        const response = await IUDAPI(data, "Enquiry/IUDEnquiry");

        if (flag == 1) {
          //if flag ==1 , add
          if (response.data.Table[0].Result === "S") {
            toast.success("Enquiry  Inserted Seccessfully", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Enquiry insert Failed", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          //if flag ==2 , update

          if (response.data.Table[0].Result === "M") {
            toast.success("Enquiry modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Enquiry modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        // data to be send to api, if add/update

        txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
        enquiryDate: formData.enquirydate,
        mstEnquiryTypeId: formData.enquirytype,
        bookingFrom: formData.fromdate,
        bookingTo: formData.todate,
        noOfDays: formData.noofdays,
        firstName: formData.fname,
        LastName: formData.lname,
        mobileNumber: formData.number,
        mstCountryId: formData.country,
        mstStateId: formData.state,
        city: formData.city,
        streetDoorNo: formData.street,
        area: formData.area,
        pincode: formData.pincode,
        mstSourceTypeId: formData.sourcetype,
        source: formData.source,
        contactNumber: formData.contactNumber,
        mstIdProofId: formData.idproof,
        idNumber: formData.idvalue,
        amount: formData.amount,
        createdBy: createdBy,
        flag: flag,
        enquiryChild: JSON.stringify(tableData),
      };

      const response = await IUDAPI([data], "Enquiry/IUDEnquiry");

      if (flag == 3) {
        //if flag ==3 , delete
        if (response.data.Table[0].Result === "D") {
          toast.success("Cancellation Reason Data Deleted Successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete Cancellation Reason", {
            duration: 3000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 3000);
      }
    }
  };

  const navigate = useNavigate();

  const validateForm = (action) => {
    let formValid = true;
    const newErrors = {};
    let fieldsToValidate = [];

    if (action === "save") {
      fieldsToValidate = ["fname", "number", "fromdate", "todate"];
    }

    fieldsToValidate.forEach((key) => {
      const value = formData[key] || "";
      const field = fieldLabels[key];

      if (!field) return; // skip unknown fields

      const { label, type } = field;

      if (value.trim() === "") {
        const message =
          type === "select-one" ? `Select ${label}` : `Enter ${label}`;
        newErrors[key] = message;
        formValid = false;
      }
    });
    setErrors(newErrors);
    return formValid;
  };
  const [bindEnquiryData, setBindEnquiryData] = useState([]);

  const [bindBookingData, setBindBookingData] = useState([]);

  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  var clientId = sessionStorage.getItem("MstClientId");

  //booking confirm

  const [popUpBookOpen, setpopUpBookOpen] = useState(false);
  const [popUpLostOpen, setpopUpLostOpen] = useState(false);
  const [popUpHoldOpen, setpopUpHoldOpen] = useState(false);
  const [popUpCancelOpen, setpopUpCancelOpen] = useState(false);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    BindEnquiryrData();

    setFormData({
      fname: "",
      lname: "",
      number: "",
      villaname: "",
      enquirydate: new Date(),
      enquiryid: "",
      enquirytype: "",
      villatype: "",
      fromdate: "",
      todate: "",
      villaselect: [],
      amount: "",
      lostreason: "",
    });
  };
  const cancel = () => {
    setViewPopUp(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setpopUpOpen(false);
    setpopUpBookOpen(false);
    setpopUpCancelOpen(false);
    setConfirmRecord("");
    setLostRecord("");
    setHoldRecord("");
    setpopUpHoldOpen(false);
    setpopUpLostOpen(false);
    BindEnquiryrData();
    setErrors({
      fname: "",
      lname: "",
      number: "",
      email: "",
      pincode: "",
      city: "",
      street: "",
      door: "",
      country: "",
      state: "",
      district: "",
      villaname: "",
      villatype: "",
      enquirydate: "",
      enquiryid: "",
      enquirytype: "",
      fromdate: "",
      todate: "",
      adults: "",
      children: "",
      idproof: "",
      idvalue: "",
      amount: "",
      lostreason: "",
    });
  };

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);


  const handleSubmit = async (items, flag) => {
    
    
    if (flag === 3) {

      // Handle delete / activate / inactivate
      const data = {
        txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
        createdby: parseInt(createdBy),
        flag,
      };

      const response = await IUDAPI(data, "Enquiry/RoomBookingDelete");
      const result = response?.data?.Table?.[0]?.Result;

      if (flag === 3 && result === "D") {
        toast.success("Deleted successfully 🗑️");
        await BindEnquiryrData();
        setTimeout(cancel, 3000);
      }
    }
  };

  const handleEdit = async (rowIndex, flag) => {
    const value = bindBookingData[rowIndex];
    const txnEnquiryId = value.TxnEnquiryId;
    setViewPopUp(true);
    const updatedValue = {
      ...value, // copy all existing fields
      TotalAmount: value.BookingTotalAmount,
      ReceivedAmount: value.BookingReceivedAmount,
      BalanceAmount: value.BookingBalanceAmount,
      PaymentType: value.BookingPaymentType,
      PaymentRefNumber: value.BookingPaymentReferenceNumber,
      ShowImage: value.BookingPaymentReference,
    };
    const drpdetailsData = [
      countryDropdown,
      stateDropdown,
      referralsource,
      iddropdown,
      roomtype,
      paymentType,
      citydropdown,
    ];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    const groupedTable = {};
    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
      if (!groupedTable[key]) {
        groupedTable[key] = item;
      }
    });

    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(groupedTable)
      // .filter((item) => item.BookingNoOfRequiredRooms > 0)
      .map((item) => ({
        RoomTypeId: item.MstRoomTypeId,
        RoomType: item.RoomType,
        RoomId: item.RoomId,
        AvailableRoomsId: "",

        SelectedRoomIds: item.SelectedRoomIds, // will be fetched
        selectedRooms: item.SelectedRoomIds, // will be fetched
        AvailableRooms: item.BookingNoOfAvailableRooms, // will be fetched
        Numberofrooms: item.BookingNoOfRequiredRooms,
        NumberofEnquiryRooms: item.NoOfRequiredRooms,
        numberofadults: item.BookingNoOfAdults,
        numberofchildren: item.BookingNoOfChildren,
        Tariff: item.BookingBasicTariff,
        specialtariff: item.BookingSpecialTariff,
        amount: item.BookingAmount * item.BookingNoOfRequiredRooms,
        Photo: item.Photo,
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        Bedrooms: item.Bedrooms,
        Balcony: item.Balcony,
        LivingRoom: item.LivingRoom,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
      }));

    // Step 4: Show popup now, will fill data next
    //  handleDeleteRow(0);
    setConfirmRecord2([]);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    // setTableData(roomTableDetailsData); // temporary without availableRooms

    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? null;
        } else {
          //    row.AvailableRoomsId = "";
          row.AvailableRooms = null;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        //   row.AvailableRoomsId = "";
        row.AvailableRooms = null;
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);

    setConfirmRecord(updatedValue);
    setpopUpBookOpen(true);
  };
  const [confirm, setConfirmRecord] = useState("");
  const [confirm1, setConfirmRecord1] = useState("");
  const [confirm2, setConfirmRecord2] = useState([]);
  const [bindenquiryChildData, setbindenquiryChildData] = useState([]);

  const appendToTableData = (newDataString) => {
    //
    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
      return {
        RoomTypeId: data.MstRoomTypeId,
        AvailableRooms: data.NoOfAvailableRooms,
        Numberofrooms: data.NoOfRequiredRooms,
        numberofadults: data.NoOfAdults,
        numberofchildren: data.NoOfChildren,
        Tariff: data.BasicTariff,
        specialtariff: data.SpecialTariff,
        amount: data.Amount,

        Size: data.Size,
        MaxOccupancy: data.MaxOccupancy,
        Bedrooms: data.Bedrooms,
        RoomType: data.RoomType,
        Balcony: data.Balcony,
        LivingRoom: data.LivingRoom,
        SpaceDetails: data.SpaceDetails,
        AmenitiesDetails: data.AmenitiesDetails,
      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    //convertArrayToJSONString(formattedDataArray);
  };

  const toYMD = (dateStr) => {
    // dateStr format: "DD-MM-YYYY"
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };
  const onConfirmBooking = async (rowIndex, flag) => {
    
    setViewPopUp(false);
    const value = bindEnquiryData[rowIndex];
    const txnEnquiryId = value.TxnEnquiryId;

    // Update only required fields
    const updatedValue = {
        ...value, // keeps all existing fields unchanged

        // you can override anything you need
       
        BookingPersonFirstName: value.FirstName,
        BookingPersonLastName: value.LastName,
        BookingPersonMobileNumber: value.MobileNumber,
        BookingPersonMstCityId: value.MstCityId,
        BookingPersonMstStateId: value.MstStateId,
        BookingPersonMstCountryId: value.MstCountryId,
        BookingPersonStreetDoorNo: value.StreetDoorNo,
        BookingPersonArea: value.Area,
        BookingPersonPincode: value.Pincode,
        BookingContactNumber: value.ContactNumber,
    };

    setConfirmRecord(updatedValue);

    const drpdetailsData = [
      countryDropdown,
      stateDropdown,
      referralsource,
      iddropdown,
      villatypedropdown,
      paymentType,
      citydropdown,
    ];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    const groupedTable = {};
    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
      if (!groupedTable[key]) {
        groupedTable[key] = item;
      }
    });

    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(groupedTable).map((item) => ({
      RoomTypeId: item.MstRoomTypeId,
      RoomType: item.RoomType,
      RoomId: item.RoomId,
      AvailableRoomsId: "", // will be fetched
      AvailableRoomsName: "",
      AvailableRooms: item.NoOfAvailableRooms, // will be fetched
      Numberofrooms: item.NoOfRequiredRooms,
      NumberofEnquiryRooms: item.NoOfRequiredRooms,
      numberofadults: item.NoOfAdults,
      numberofchildren: item.NoOfChildren,
      Tariff: item.BasicTariff,
      specialtariff: item.SpecialTariff,
      amount: item.Amount,
      Photo: item.Photo,
      Size: item.Size,
      MaxOccupancy: item.MaxOccupancy,
      Bedrooms: item.Bedrooms,
      Balcony: item.Balcony,
      LivingRoom: item.LivingRoom,
      SpaceDetails: item.SpaceDetails,
      AmenitiesDetails: item.AmenitiesDetails,
    }));

    // Step 4: Show popup now, will fill data next
    handleDeleteRow(0);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    setpopUpBookOpen(true);

    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? null;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          row.AvailableRoomsId = "";
          row.AvailableRooms = null;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        row.AvailableRoomsId = "";
        row.AvailableRooms = null;
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);
  };

  const [holdrecord, setHoldRecord] = useState("");
  const onHoldEnquiry = (rowIndex, flag) => {
    if (flag === 1) {
      setRowIndex(rowIndex);
      setpopUpHoldOpen(true);
      //onSave()
      handleSubmit();

      const holdData = {
        fname: formData.fname,
        lname: formData.lname,
        number: formData.number,
        fromdate: formData.fromdate,
        todate: formData.todate,
        enquiryid: formData.enquiryid,
        enquirydate: formData.enquirydate,
      };
      setHoldRecord(holdData);
    } else {
      setpopUpHoldOpen(true);
      const holdDatapop = {
        fname: bindEnquiryData[rowIndex].FirstName,
        lname: bindEnquiryData[rowIndex].LastName,
        number: bindEnquiryData[rowIndex].MobileNumber,
        fromdate: bindEnquiryData[rowIndex].BookingFrom.split("T")[0],
        todate: bindEnquiryData[rowIndex].BookingTo.split("T")[0],
        enquiryid: bindEnquiryData[rowIndex].EnquiryNo,
        enquirydate: bindEnquiryData[rowIndex].EnquiryDate.split("T")[0],
      };

      setHoldRecord(holdDatapop);
    }
  };

  const validateTableData = () => {
    let isValid = true;
    const errors = [];

    tableData.forEach((row, index) => {
      const rowErrors = {};

      // Required dropdown (RoomTypeId)
      if (!row.RoomTypeId) {
        rowErrors.RoomTypeId = "Room Type is required";
        isValid = false;
      }

      // AvailableRooms should be a number (optional: if not empty)
      if (row.AvailableRooms && isNaN(row.AvailableRooms)) {
        rowErrors.AvailableRooms = "Available Rooms must be a number";
        isValid = false;
      }

      // Tariff should be a number
      if (row.Tariff && isNaN(row.Tariff)) {
        rowErrors.Tariff = "Tariff must be a number";
        isValid = false;
      }

      // Special tariff can be optional, but if present must be a number
      if (!row.specialtariff && isNaN(row.specialtariff)) {
        rowErrors.specialtariff = "Special Tariff must be a number";
        isValid = false;
      }

      // Number of Rooms - required and must be a number > 0
      if (!row.Numberofrooms || isNaN(row.Numberofrooms) || parseInt(row.Numberofrooms) <= 0) {
        rowErrors.Numberofrooms = "Number of rooms must be greater than 0";
        isValid = false;
      }

      // Adults
      if (!row.numberofadults || isNaN(row.numberofadults) || parseInt(row.numberofadults) <= 0) {
        rowErrors.numberofadults = "Number of adults must be greater than 0";
        isValid = false;
      }

      // Children
      if (!row.numberofchildren && isNaN(row.numberofchildren)) {
        rowErrors.numberofchildren = "Number of children must be a number";


        // toast.error("Number of children must be a number", {
        //       duration: 3000,
        //       position: "top-center",
        //     });
        isValid = false;
      }

      // Amount – required and must be a number
      if (!row.amount || isNaN(row.amount) || parseFloat(row.amount) <= 0) {
        rowErrors.amount = "Amount must be a positive number";
        isValid = false;
      }

      errors.push(rowErrors);
    });

    if (!isValid) {
      console.log("Validation Errors:", errors);
      // Optionally set this in state for UI display
    }

    return isValid;
  };

  const [lostRecord, setLostRecord] = useState("");
  const onLostEnquiry = async (rowIndex, flag) => {
    
    //
    setpopUpLostOpen(true); // move this AFTER data is set
    if (flag === 1) {

      const isValid = validateForm("save"); // Validate only save fields

      if (flag == 1 || flag == 2) {
        if (!isValid) {
          setIsOpen(true);
          setIsLoading(false);
          setSubmitBtnDisabled(false);
        }
        if (validateTableData()) {
          // Proceed to submit

          if (isValid) {
            setIsOpen(false);
            setIsLoading(true);
            setSubmitBtnDisabled(true);
            const filteredTableData = tableData.filter(
              (row) => row.RoomTypeId && row.RoomTypeId !== ""
            );
            const data = {
              txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
              enquiryNo: "ENQ" || bindEnquiryData[rowIndex].TxnEnquiryId,
              mstClientId: clientId,
              enquiryDate: formData.enquirydate,
              mstEnquiryTypeId: formData.enquirytype || 0,
              bookingFrom: formData.fromdate,
              bookingTo: formData.todate,
              noOfDays: formData.noofdays || 0,
              //done
              firstName: formData.fname || "",
              lastName: formData.lname || "",
              mobileNumber: formData.number || "",
              //done
              mstCountryId: formData.country || 0,
              mstStateId: parseInt(formData.state) || null,
              city: formData.city || 0,

              stateName: formData.statename || "",
              cityName: formData.cityname || "",
              streetDoorNo: formData.streetdoorno || "",
              area: formData.area || "",
              pincode: formData.pincode || "",
              mstSourceTypeId: formData.sourcetype || 0,
              contactNumber: formData.referralcontact || "",
              mstIdProofId: formData.idproof || 0,

              idNumber: formData.idvalue || "",
              source: formData.source || "",

              //belowdone
              amount: formData.amountpaid || 0,
              mstEnquiryStatusId: "1" || 0,
              createdBy: createdBy,
              flag: flag,
              enquiryChild: JSON.stringify(filteredTableData),
              //enquiryChild: '[{ \"mstRoomTypeId\": 1, \"mstRoomId\": 2, \"noOfAvailableRooms\": 2, \"basicTariff\": 2500, \"specialTariff\": 500, \"noOfRequiredRooms\": 1, \"noOfAdults\": 1, \"noOfChildren\": 2, \"amount\": 3500, \"mstEnquiryStatusId\": 1, \"mstHoldReasonId\": 0, \"holdFollowUpDate\": \"2025-07-11\", \"mstHoldReasonNotes\": \"Some note\", \"mstLostReasonId\": 0, \"lostReasonNotes\": \"Another note\" }]'
            };
            console.log(tableData);

            const response = await IUDAPI(data, "Enquiry/IUDEnquiry");
            console.log(data);
            console.log("formData:", formData);

            if (flag == 1) {
              //if flag ==1 , add
              if (response.data.Table[0].Result === "S") {

                const selectedRow = response.data.Table1[0];
                const lostDataPop = {
                  fname: selectedRow.FirstName,
                  lname: selectedRow.LastName,
                  number: selectedRow.MobileNumber,
                  fromdate: selectedRow.BookingFrom.split("T")[0],
                  todate: selectedRow.BookingTo.split("T")[0],
                  enquiryid: selectedRow.EnquiryNo,
                };
                setLostRecord(lostDataPop);

                const TesttxnEnquiryId = response.data.Table1[0].TxnEnquiryId;
                setChildId(TesttxnEnquiryId);

                // Step 1: Filter data for this enquiry
                // const filtered = bindenquiryChildData.filter(
                //   (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
                // );
                const filtered = response.data.Table2
                // Step 2: Group by RoomTypeId or RoomType
                const grouped = {};
                filtered.forEach((item) => {
                  const key = item.MstRoomTypeId || item.RoomType;

                  if (!grouped[key]) {
                    // First room of this type
                    grouped[key] = {
                      ...item,
                      NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0),
                    };
                  } else {
                    // Add to existing group
                    grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
                  }
                });

                // Step 3: Final data for table
                const roomDetailsData = Object.values(grouped).map((item) => ({
                  TxnEnquiryId: item.TxnEnquiryId,
                  RoomTypeId: item.MstRoomTypeId,
                  RoomType: item.RoomType,
                  Photo: item.Photo
                    ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
                      ? item.Photo
                      : `data:image/jpeg;base64,${item.Photo}`
                    : "",
                  Size: item.Size,
                  MaxOccupancy: item.MaxOccupancy,
                  SpaceDetails: item.SpaceDetails,
                  AmenitiesDetails: item.AmenitiesDetails,
                  NoOfRequiredRooms: item.NoOfRequiredRooms, // ✅ Already summed!
                  AvailableRoomsName: item.AvailableRoomsName || "",
                }));

                // Step 4: Push to table
                handleDeleteRow(0);
                setLostTableData(roomDetailsData);

              } else {
                toast.error("Enquiry insert Failed", {
                  duration: 3000,
                  position: "top-center",
                });
                setTimeout(cancel, 3000);
              }
            } else if (flag == 2) {
              //if flag ==2 , update

              if (response.data.Table[0].Result === "M") {

                const selectedRow = bindEnquiryData[rowIndex];
                const lostDataPop = {
                  fname: selectedRow.FirstName,
                  lname: selectedRow.LastName,
                  number: selectedRow.MobileNumber,
                  fromdate: selectedRow.BookingFrom.split("T")[0],
                  todate: selectedRow.BookingTo.split("T")[0],
                  enquiryid: selectedRow.EnquiryNo,
                };
                setLostRecord(lostDataPop);

                const TesttxnEnquiryId = bindEnquiryData[rowIndex].TxnEnquiryId;
                setChildId(TesttxnEnquiryId);

                // Step 1: Filter data for this enquiry
                const filtered = bindenquiryChildData.filter(
                  (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
                );

                // Step 2: Group by RoomTypeId or RoomType
                const grouped = {};
                filtered.forEach((item) => {
                  const key = item.MstRoomTypeId || item.RoomType;

                  if (!grouped[key]) {
                    // First room of this type
                    grouped[key] = {
                      ...item,
                      NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0),
                    };
                  } else {
                    // Add to existing group
                    grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
                  }
                });

                // Step 3: Final data for table
                const roomDetailsData = Object.values(grouped).map((item) => ({
                  TxnEnquiryId: item.TxnEnquiryId,
                  RoomTypeId: item.MstRoomTypeId,
                  RoomType: item.RoomType,
                  Photo: item.Photo
                    ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
                      ? item.Photo
                      : `data:image/jpeg;base64,${item.Photo}`
                    : "",
                  Size: item.Size,
                  MaxOccupancy: item.MaxOccupancy,
                  SpaceDetails: item.SpaceDetails,
                  AmenitiesDetails: item.AmenitiesDetails,
                  NoOfRequiredRooms: item.NoOfRequiredRooms, // ✅ Already summed!
                  AvailableRoomsName: item.AvailableRoomsName || "",
                }));

                // Step 4: Push to table
                handleDeleteRow(0);
                setLostTableData(roomDetailsData);


              } else {
                toast.error("Enquiry modification failed 👎", {
                  duration: 3000,
                  position: "top-center",
                });
                setTimeout(cancel, 3000);
              }
            }

          } else {
            setSubmitBtnDisabled(false);
          }

        }

        setIsLoading(false)
      }



      //   // Flag 1: form-based data
      //   setRowIndex(rowIndex);
      //   const lostData = {
      //     fname: formData.fname,
      //     lname: formData.lname,
      //     number: formData.number,
      //     fromdate: formData.fromdate,
      //     todate: formData.todate,
      //     enquiryid: formData.enquiryid,
      //   };
      //   setLostRecord(lostData);
      //   setpopUpLostOpen(true);
      //  // handleSubmit();

      // setpopUpLostOpen(false);
      // setVisibleTable(true)







    } else {
      // Flag not 1: table row based
      const selectedRow = bindEnquiryData[rowIndex];
      const lostDataPop = {
        fname: selectedRow.FirstName,
        lname: selectedRow.LastName,
        number: selectedRow.MobileNumber,
        fromdate: selectedRow.BookingFrom.split("T")[0],
        todate: selectedRow.BookingTo.split("T")[0],
        enquiryid: selectedRow.EnquiryNo,
      };
      setLostRecord(lostDataPop);

      const TesttxnEnquiryId = bindEnquiryData[rowIndex].TxnEnquiryId;
      setChildId(TesttxnEnquiryId);

      // Step 1: Filter data for this enquiry
      const filtered = bindenquiryChildData.filter(
        (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
      );

      // Step 2: Group by RoomTypeId or RoomType
      const grouped = {};
      filtered.forEach((item) => {
        const key = item.MstRoomTypeId || item.RoomType;

        if (!grouped[key]) {
          // First room of this type
          grouped[key] = {
            ...item,
            NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0),
          };
        } else {
          // Add to existing group
          grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
        }
      });

      // Step 3: Final data for table
      const roomDetailsData = Object.values(grouped).map((item) => ({
        TxnEnquiryId: item.TxnEnquiryId,
        RoomTypeId: item.MstRoomTypeId,
        RoomType: item.RoomType,
        Photo: item.Photo
          ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
            ? item.Photo
            : `data:image/jpeg;base64,${item.Photo}`
          : "",
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
        NoOfRequiredRooms: item.NoOfRequiredRooms, // ✅ Already summed!
        AvailableRoomsName: item.AvailableRoomsName || ""
      }));

      // Step 4: Push to table
      handleDeleteRow(0);
      setLostTableData(roomDetailsData);
    }
  };

  const [TxnEnquiryId, setTxnEnquiryId] = useState([]);

  const handleState = (rowIndex, flag) => {
    setRowIndex(rowIndex);

    setpopUpBookOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    setSelectedRecord(bindEnquiryData[rowIndex]);

    const TesttxnEnquiryId = bindEnquiryData[rowIndex].TxnEnquiryId;
    // setChildId(TesttxnEnquiryId); // still sets state for other uses

    // Use the value directly instead of waiting for state update
    const roomDetailsData = Object.values(bindenquiryChildData).filter(
      (item) => {
        return item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId);
      }
    );

    if (roomDetailsData.length === 0) {
      setTableData([
        {
          RoomTypeId: "",
          AvailableRooms: "",
          Numberofrooms: "",
          numberofadults: "",
          numberofchildren: "",
          Tariff: "",
          specialtariff: "",
          amount: "",
          Size: "",
          MaxOccupancy: "",
          Bedrooms: "",
          RoomType: "",
          Balcony: "",
          LivingRoom: "",
        },
      ]);
    } else {
      appendToTableData(JSON.stringify(roomDetailsData));
    }
  };
  const onViewEnquiry = (rowIndex, flag) => {
    
    onCancelEnquiry(rowIndex, flag);
    setViewPopUp(true);
  };
  const onCancelEnquiry = async (rowIndex, flag) => {

    setViewDetails(false);
  setDeleteDetails(false);
  setBlockDetails(false);
  setUnBlockDetails(false);

  // 2️⃣ Decide title based on flag
  if (flag === 3) {
    setDeleteDetails(true);   // Cancel
  } else if (flag === 1) {
    setViewDetails(true);     // View
  }
    
    setViewPopUp(false);
    const value = bindBookingData[rowIndex];
      // Update only required fields
    const updatedValue = {
        ...value, // keeps all existing fields unchanged

        // you can override anything you need
        BookingPersonNoOfDays: value.NoOfDays,
        BookingPersonFirstName: value.FirstName,
        BookingPersonLastName: value.LastName,
        BookingPersonMobileNumber: value.MobileNumber,
        BookingPersonMstCityId: value.MstCityId,
        BookingPersonMstStateId: value.MstStateId,
        BookingPersonMstCountryId: value.MstCountryId,
        BookingPersonStreetDoorNo: value.StreetDoorNo,
        BookingPersonArea: value.Area,
        BookingPersonPincode: value.Pincode,
        BookingContactNumber: value.ContactNumber,
    };
    const txnEnquiryId = value.TxnEnquiryId;
    setTxnEnquiryId(txnEnquiryId)
    const drpdetailsData = [
      countryDropdown,
      stateDropdown,
      referralsource,
      iddropdown,
      roomtype,
      paymentType,
      citydropdown,
    ];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    const groupedTable = {};
    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
      if (!groupedTable[key]) {
        groupedTable[key] = item;
      }
    });

    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(groupedTable)
      .filter((item) => item.BookingNoOfRequiredRooms > 0)
      .map((item) => ({
        RoomTypeId: item.MstRoomTypeId,
        RoomType: item.RoomType,
        RoomId: item.RoomId,
        AvailableRoomsId: item.SelectedRoomIds, // will be fetched
        AvailableRoomsName: "",
        AvailableRooms: item.BookingNoOfAvailableRooms, // will be fetched
        Numberofrooms: item.BookingNoOfRequiredRooms,
        numberofadults: item.BookingNoOfAdults,
        numberofchildren: item.BookingNoOfChildren,
        Tariff: item.BookingBasicTariff,
        specialtariff: item.BookingSpecialTariff,
        amount: item.BookingAmount * item.BookingNoOfRequiredRooms,
        Photo: item.Photo,
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        Bedrooms: item.Bedrooms,
        Balcony: item.Balcony,
        LivingRoom: item.LivingRoom,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
      }));

    // Step 4: Show popup now, will fill data next
    //  handleDeleteRow(0);
    setConfirmRecord2([]);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    // setTableData(roomTableDetailsData); // temporary without availableRooms

    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          //  row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? null;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          //    row.AvailableRoomsId = "";
          row.AvailableRooms = null;
          row.AvailableRoomsName = "";
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        //   row.AvailableRoomsId = "";
        row.AvailableRooms = 0;
        row.AvailableRoomsName = "";
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);

    setConfirmRecord(updatedValue);
    setpopUpCancelOpen(true);
    if (flag == 3) {
      setDeleteDetails(true)

      setViewDetails(false)
    } else if (flag == 1) {
      setViewDetails(true)

      setDeleteDetails(false)
    }
  };

  const [selectedRecord, setSelectedRecord] = useState({});

  const handleDeleteRow = (index) => {
    setTableData((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      return updated.length
        ? updated
        : [
          {
            villaname: "",
            villatype: "",
          },
        ];
    });
  };

  useEffect(() => {
    const total = tableData.reduce(
      (sum, row) => sum + (Number(row.amount) || 0),
      0
    );

    setFormData((prev) => ({
      ...prev,
      amountpaid: total,
    }));
  }, [tableData]);
  var clientId = sessionStorage.getItem("MstClientId");
  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    const data = {
      mstClientId: clientId,
    };
    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    if (response && response.data) {
      const enquiryTypeId = response.data.Table1.map((item) => ({
        value: item.MstEnquiryTypeId,
        label: item.EnquiryType,
      }));

      setenquirydropdown(enquiryTypeId);

      const countryId = response.data.Table2.map((item) => ({
        value: item.MstCountryId,
        label: item.CountryName,
      }));

      setCountryDropdown(countryId);

      const stateId = response.data.Table3.map((item) => ({
        value: item.MstStateId,
        label: item.State,
        MstCountryId: item.MstCountryId,
      }));

      setStateDropdown(stateId);

      const cityId = response.data.Table4.map((item) => ({
        value: item.MstCityId,
        label: item.City,
        MstStateId: item.MstStateId,
      }));

      setCityDropdown(cityId);

      const idProofId = response.data.Table5.map((item) => ({
        value: item.MstIdProofId,
        label: item.IdProof,
      }));

      setiddropdown(idProofId);

      const referralsourceid = response.data.Table6.map((item) => ({
        value: item.MstReferralSourceId,
        label: item.ReferralSource,
      }));
      setreferralsource(referralsourceid);

      const RoomTypeid = response.data.Table7.map((item) => ({
        value: item.MstRoomtypeId,
        label: item.RoomType,
      }));
      setroomtype(RoomTypeid);
      const PaymentTypeId = response.data.Table10.map((item) => ({
        value: item.MstPaymentTypeId,
        label: item.PaymentTypeId,
      }));
      setPaymentType(PaymentTypeId);
      //setTableData(RoomTypeid.length)
    } else {
      setBindEnquiryData([]);
    }
  };

  useEffect(() => {
    BindEnquiryrData();
  }, [onSubmit]);

  const BindEnquiryrData = async () => {
    setIsLoading(true);
    const data = {
      mstClientId: clientId,
    };

    const response = await BindPostAPI(data, "Enquiry/BindEnquiry");
    if (response && response.data) {
      const filterEnquiryData = response.data.Table.filter(
        // (item) => item.MstEnquiryStatusId === 1 || item.MstEnquiryStatusId === 3
        (item) => item.MstEnquiryStatusId === 1 || item.MstEnquiryStatusId === 2
      );
      setBindEnquiryData(filterEnquiryData);
      // setBindEnquiryData(response.data.Table);
      setbindenquiryChildData(response.data.Table1);
      const filteredRecords = response.data.Table.filter(
        item => item.BookingDeletedBy === null
      );

      const filteredRecords1 = filteredRecords.filter(
        (item) =>
          item.MstEnquiryStatusId !== null && item.MstEnquiryStatusId === 4
      );
      // const filteredRecords1 = response.data.Table.filter(
      //   (item) => item.BookingNo !== null && item.BookingStatus < 5
      // );

      setBindBookingData(filteredRecords);
      setBindBookingData(filteredRecords1);
      setOnSubmit(false);
    } else {
      setBindEnquiryData([]);
      setbindenquiryChildData([]);
    }
    setIsLoading(false);
  };

  return (
    <MainLayout pageName={"3"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div class={mainTable.addScreenTitle}>Room Booking</div>
      {visibleTable && (
        <GridPage
          title={"Enquiry Details"}
          header={bookingEnquiryHeaders}
          records={bindEnquiryData}
          showAdd={showAdd}
          addbtnView={false}
          handleAction={handleState}
          handleEdit={handleEdit}
          onConfirmBooking={onConfirmBooking}
          onLostEnquiry={onLostEnquiry}
          onHoldEnquiry={onHoldEnquiry}
        />
      )}

      {visibleTable && (
        <GridPage
          title={"Booking Details"}
          header={BookingDetailsHeaders}
          CancelledBookingsBtn={true}
          records={bindBookingData}
          showAdd={showAdd}
          addbtnView={false}
          handleAction={onViewEnquiry}
          handleEdit={handleEdit}
          onConfirmBooking={onConfirmBooking}
          onLostEnquiry={onLostEnquiry}
          onHoldEnquiry={onHoldEnquiry}
          onCancelEnquiry={onCancelEnquiry}
        />
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleState}
      >
        <div>
          <PopUpScreenTitle
            title="Enquiry"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Enquirypopup data={selectedRecord} data1={popUpData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>

      <MainPopup
        popUpOpen={popUpBookOpen}
        setpopUpOpen={setpopUpBookOpen}
        Open={onConfirmBooking}
      >
        <div>
          <PopUpScreenTitle
            title={
              viewPopUp ? "Booking Confirmation - Edit" : "Booking Confirmation"
            }
            setpopUpOpen={setpopUpBookOpen}
            hederDetails={setpopUpBookOpen}
          />
          <ConfirmBookingPopUp
            data={confirm}
            data1={confirm1}
            // data2={tableData}
            data2={setOnSubmit}
            data3={confirm2} //  to import confirm booking popup component
            isOpen={setpopUpBookOpen}
            isSubmit={setOnSubmit}
            viewPopUp={viewPopUp}
          />
        </div>
      </MainPopup>

      <MainPopup
        popUpOpen={popUpLostOpen}
        setpopUpOpen={setpopUpLostOpen}
        Open={onLostEnquiry}
      >
        <div>
          <PopUpScreenTitle
            title="On Lost"
            setpopUpOpen={setpopUpLostOpen}
            hederDetails={setpopUpLostOpen}
          />


          <OnLostPopUp
            data={lostRecord} //  to import lost enquiry popup component
            data1={lostTableData}
            isOpen={setpopUpLostOpen}
          />
        </div>
        <PopUpButtons
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          cancelButtonHide={true}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>

      <MainPopup
        popUpOpen={popUpHoldOpen}
        setpopUpOpen={setpopUpHoldOpen}
        Open={onHoldEnquiry}
      >
        <div>
          <PopUpScreenTitle
            title="On Hold"
            setpopUpOpen={setpopUpHoldOpen}
            headerDetails={setpopUpHoldOpen}
          />
          <OnHoldPopUp
            data={holdrecord} //  to import Hold enquiry popup component
          />
        </div>
        <PopUpButtons
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
      <MainPopup
        popUpOpen={popUpCancelOpen}
        setpopUpOpen={setpopUpCancelOpen}
        Open={onCancelEnquiry}
      >
        <div>
        <PopUpScreenTitle
            hederDetails={true}
            title={viewPopUp ? "Booking Confirmation - View" : "On Cancel"}
            setpopUpOpen={setpopUpCancelOpen}
            headerDetails={setpopUpCancelOpen}
          />
          <Cancelpopup
            data={confirm}
            data1={confirm1}
            data2={tableData}
            data3={confirm2}
            isOpen={setpopUpCancelOpen}
            isSubmit={setOnSubmit}
            viewPopUp={viewPopUp}
          />
        </div>
        {
          <PopUpButtons
            rowIndex={rowIndex}
            handleSubmit={handleSubmit}
            deleteDetails={deleteDetails}
            cancel={cancel}
            cancelBtn={viewPopUp ? false : true}
            disabledBtn={submitBtnDisabled ? true : false}
          />
        }
      </MainPopup>
    </MainLayout>
  );
};
export default RoomBooking;
